"use client"

import { Form } from "@/components/Form/Form";
import { InputText, InputTextArea } from "@/components/Inputs";
import React, { useEffect, useState } from "react";
import { ContactUsFormProps } from "@/blocks/ContactUsForm/ContactUsForm";
import { sendEmail } from "@/actions/form.action";
import { Body, Label } from "@/client/foundations/Typography";
import { Link } from "@/components/Link/Link";
import classNames from "classnames";
import { Icons } from "@/components/Icons";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { Box } from "@/layouts/LayoutComponents";
import DropdownMenu from "@/components/DropdownMenu";
// import { Box } from "@fastlooptech/layout-components";
import { useParams } from 'next/navigation';
import { getLocale } from "@/config/app.config";
import { getData } from "@/actions/page.action";

export function ContactUsFormInline(props: ContactUsFormProps) {
  const params = useParams();
  const locale: string = (params?.locale as string) || getLocale() || "";
  const [formStatus, setFormStatus] = useState("Empty");
  const [formStatusMessage, setFormStatusMessage] = useState("");
  const [emailPurpose, setEmailPurpose] = useState<any | string>(null);
  const [locationList, setLocationList] = useState([
    'Birsta City',
    'Italie 2',
    'Livat Hammersmith',
    //'Wola Park',
    'Livat Shangai'
  ]);
  const [draggingItem, setDraggingItem] = useState(null);
  const [newLocation, setNewLocation] = useState('');
  // const storage = localStorage?.getItem("form_status") || "";
  const [storage, setStorage] = useState<string|null>(null);
  //CAPTCHA
  const [imageUrl, setImageUrl] = useState('');
  // const [audioUrl, setAudioUrl] = useState('');
  // const [randomString, setRandomString] = useState('');
  const [count, setCount] = useState(props.submitSuccess ? 2 : 0);
  const [purposeList, setPurposeList]: any[] = useState([]);
  const [dList, setDList] = useState({items: []});

  useEffect(()=>{
    setFormStatus("Empty");
    setFormStatusMessage("");
    setEmailPurpose(null);
    setLocationList([
      'Birsta City',
      'Italie 2',
      'Livat Hammersmith',
      //'Wola Park',
      'Livat Shangai'
    ]);
    setDraggingItem(null);
    setNewLocation("");
    setImageUrl("");
    setCount(props.submitSuccess ? 2 : 0);
    setPurposeList([]);

    (async ()=>{setDList(await getData({tags: "futuresContactFormDropdown"}) as any)})()
    const st = localStorage?.getItem("form_status") || "";
    setStorage(st);
    if(st === "Success"){
      setFormStatus("Success");
    }
  }, [])



  useEffect(()=>{
    let arr = (()=>{
      return (dList?.items || [])?.map((item: any)=>{
        return {
          value: item?.id || "",
          internalName: item?.content?.internalName || "",
          name: item?.content?.caption || ""
        }
      })
    })();

    arr.sort((a, b) => a.internalName.localeCompare(b.internalName));
    setTimeout(()=>{
      setPurposeList(arr);
    }, 10)
  }, [dList])

  const handleCaptchaReset = () => {
    setCount(count + 1);
  }

  const handleDragStart = (e: any, item: any) => {
    setDraggingItem(item);
    e.dataTransfer.setData('text/plain', '');
  };

  const handleDragEnd = () => {
    setDraggingItem(null);
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
  };

  const handleDrop = (e: any, targetItem: any) => {
    if (!draggingItem) return;

    const currentIndex = locationList.indexOf(draggingItem);
    const targetIndex = locationList.indexOf(targetItem);

    if (currentIndex !== -1 && targetIndex !== -1) {
      const items = locationList;
      items.splice(currentIndex, 1);
      items.splice(targetIndex, 0, draggingItem);
      setLocationList(items);
    }
  };

  const handleNewLocation = (e: any) => {
    setNewLocation(e.target.value);
  }

  const onAddLocation = () => {
    if (newLocation) {
      setLocationList([...locationList, newLocation]);
      setNewLocation('');
    }
  }

  const onRemoveLocation = (index: number) => {
    locationList.splice(index, 1);
    setLocationList([...locationList]);
  }

  const handleSubmit = async (event: any) => {
    setFormStatusMessage("");
    setFormStatus("Dirty");
    const CRLFregex = /(\r\n|\n|\r)/gm;

    const data: any = {
      language: event?.target?.language?.value,
      name: event?.target?.name?.value,
      email: event?.target?.email?.value,
      confirmEmail: event?.target?.confirmEmail?.value,
      company: event?.target?.company?.value,
      // purpose: event?.target?.purpose?.value,
      emailPurpose: event?.target?.emailPurpose?.value,
      emailPurposeId: event?.target?.emailPurposeId?.value,
      date: event?.target?.date?.value,
      message: event?.target?.message?.value?.replace(CRLFregex, ''),
      emailRecepients: props?.emailRecepients,
      // locationList,
      isModal: props?.submitSuccess
    };

    // Regex CHECK
    // const regex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    // const regex = /^[a-zA-Z0-9_.-@&$*!#\[\]\s][^><]*$/gi;
    const regex = /^[^><]*$/g;
    for(const key in data) {
      // if(!regex.test(data[key])) {
      if(data[key] && !String(data[key])?.match(regex)) {
        setFormStatusMessage("Form field(s) can not accept > or <");
        setFormStatus("Warning");
        setTimeout(()=>{
          setFormStatusMessage('');
          setFormStatus("");
          },5000)
        return;
      } else {
        setFormStatusMessage('');
        setFormStatus("");
      }
    }

    // Regex for handling CR and LF
    // const CRLFregex = /^[^\r\n]+$/g;
    // if(data['message'] && !String(data['message'])?.replace(CRLFregex, '')) {
    //   setFormStatusMessage("Please remove CR(Carriage Return)/LF(Line Feed) from message");
    //   setFormStatus("Warning");
    //   setTimeout(()=>{
    //     setFormStatusMessage('');
    //     setFormStatus("");
    //     },5000)
    //   return;
    // } else {
    //   setFormStatusMessage('');
    //   setFormStatus("");
    // }
    

    // EMAIL CONFIRMATION CHECK
    if (data.email.toUpperCase() !== data?.confirmEmail.toUpperCase()) {
      setFormStatusMessage("Please check Confirm email field");
      setFormStatus("Warning");
      setTimeout(()=>{
        setFormStatusMessage('');
        setFormStatus("");
        },5000)
      return;
    }

    // CHECK CAPTCHA
    if (count > 1 && imageUrl && !event?.target?.captchaPassword?.value) {
      setFormStatusMessage("Captcha field is empty");
      setFormStatus("Warning");
      setTimeout(()=>{
        setFormStatusMessage('');
        setFormStatus("");
        },5000)
      return;
    }

    //CAPTCHA
    let resp = {success: true};
    if ((resp?.success && count > 1) || count <= 1) {
      setFormStatus("Loading");

      console.log("send email --- ", data)
      // return;
      //Call Form Action sendEmail

      sendEmail({
        ...data,
        // emailPurpose: emailPurpose,
        forwardingEmailSubject: props?.forwardingEmailSubject,
        responseEmailSubject: props?.responseEmailSubject,
        responseEmailTemplate: props?.responseEmailTemplate && documentToHtmlString(props?.responseEmailTemplate),
        forwardingEmailTemplate: props?.forwardingEmailTemplate && documentToHtmlString(props?.forwardingEmailTemplate),
        topImage: props?.topImage ? "https:" + props?.topImage : null,
        bottomImage: props?.bottomImage ? "https:" + props?.bottomImage : null
      })
        .then((response: any) => {
          console.log('SendEmail feedback', response);
          // if( props?.inModal ){
            localStorage?.setItem("form_status", "Success");
          // }
          if(response?.error) {
            throw new Error('Error: server error!');
          }
          setFormStatus("Success");
          // sendEventToGTM({ event: "form_submit", eventModel: "" });

          // if (props.inModal) {
          //   window.dispatchEvent(new Event('ModalFormSubmitted'));
          // }

          if (props.onSubmit) {
            props.onSubmit();
          }
        })
        .catch(() => {
          setFormStatus("Error");
        });
    } else if (!resp?.success) {
      setFormStatus('Error');
      setFormStatusMessage('Invalid Captcha!');
      setCount(count + 1);
    }
  };

  return (
    <Box className="w-full !flex-auto bg-interactive-circuit-contact-form rounded-circuit-contact-form px-circuit-contact-form-X py-circuit-contact-form-Y">
      {/* {formStatus} */}
      {formStatus === "Success" ? (
        <Box column hAlignContent="center" vAlignContent="center" className="w-full">
          {/* <Heading size="m">{props.thankYouMessage || props.thankYouTitle || 'Thank you for your submission!'}</Heading> */}
          <Body size="m" id="success-submit-message" className="pt-2 !font-bold px-6">
            {props.thankYouMessage || props.thankYouTitle || 'Thank you for your submission!'}
          </Body>
        </Box>
      ) : (
        <Form
          id="contact-us-form"
          action={handleSubmit}
          className="w-full"
          submitLabel={props.submitLabel || "Get your future started"}
          status={formStatus}
          statusMessage={formStatusMessage}
          inModal={props.inModal}
        >
          <div className="w-full flex flex-col gap-form-gap">

          {/* <pre>{JSON.stringify(purposeList, null, 2)}</pre> */}
            <InputText id="language" name="language" type="hidden" value={locale} />
            <InputText id="name" name="name" type="text" placeholder="Enter full name" label={props.nameFieldLabel || 'Name'}
              required={true} />
            <InputText id="email" name="email" type="email" placeholder="Enter email address" label={props.emailFieldLabel || 'Email'}
              required={true} />
            <InputText id="confirmEmail" name="confirmEmail" placeholder="Confirm your email address" type="email"
              label={props.confirmEmailFieldLabel || 'Confirm Email'}
              required={true} />
            <InputText id="company" name="company" type="text" placeholder="Enter company name" label={props.companyFieldLabel || 'Company'}
              required={true} />
            <DropdownMenu id='purpose-dropdown' name='purpose' label='Purpose' setSelectedValue={(e: any)=>{ console.log("------ eeeee -----", e); setEmailPurpose(purposeList?.find((p: any)=>p.value === e))}} options={
              [
                {value: '', name: 'Please select an option'},
                // {value: 'co-creating a new business', name: 'co-creating a new business'}, 
                // { value: 'renting out space for my business', name: 'renting out space for my business'}, 
                // { value: 'something else', name: 'something else'}
                ...purposeList
              ]} required={true}>
                <>
                  <input id="emailPurpose" name="emailPurpose" title="emailPurpose" className="hide-input" type="text" onInvalid={(e: any)=>{
                    if(e?.currentTarget?.value === "") {
                      e.currentTarget.setCustomValidity('Please select an option')
                    } else {
                      e.currentTarget.setCustomValidity('')
                    }
                    return true;
                  }} value={emailPurpose?.name} />
                  <input id="emailPurposeId" name="emailPurposeId" title="emailPurposeId" className="hide-input" type="text" onInvalid={(e: any)=>{
                    if(e?.currentTarget?.value === "") {
                      e.currentTarget.setCustomValidity('Please select an option')
                    } else {
                      e.currentTarget.setCustomValidity('')
                    }
                    return true;
                  }} value={emailPurpose?.value} required={true} />
                </>
            </DropdownMenu>

            {/* <InputDropDown 
              id="purpose" 
              name="purpose"
              label={props.confirmEmailFieldLabel || 'Purpose'}
              required={true}
              options={[
                {value: '', label: 'Select an option'},
                {value: 'co-creating a new business', label: 'co-creating a new business'}, 
                { value: 'renting out space for my business', label: 'renting out space for my business'}, 
                { value: 'something else', label: 'something else'}
              ]}
            /> */}

            {props.enableLocationByPreference && 
              <>
                <Label>{props.locationsFieldLabel || 'Sort Location by Preference'}</Label>
                <ul>
                  {locationList.map((location, index) => {
                    return <li key={`ContactUsFormInline-${index}`}
                      className={classNames('w-full mb-2 flex gap-x-2 content-center items-center select-none')}>
                      <div className={classNames(
                        'bg-base-white px-2 py-1 border border-solid border-base-grey flex gap-x-2 content-center items-center select-none font-extrabold'
                      )}>{index + 1}</div>
                      <div draggable={true} className={classNames(
                        'w-full bg-base-white px-2 py-1 border border-solid border-base-grey flex justify-between content-center items-center select-none',
                        `${location === draggingItem ? ' cursor-grabbing' : 'cursor-grab'}`
                      )}
                        onDragStart={(e) => handleDragStart(e, location)}
                        onDragEnd={handleDragEnd}
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleDrop(e, location)}
                      >
                        <div className={"flex gap-x-2 content-center items-center select-none"}>
                          <Icons.DragHandler size={'s'} id={'drag-handler-icon'}
                            className={'cursor-grab'}></Icons.DragHandler>
                          {location}
                        </div>
                        <Icons.Close id={'list-remove-icon'} size={'s'} className={'cursor-pointer'}
                          onClick={() => onRemoveLocation(index)}></Icons.Close>
                      </div>
                    </li>
                  })}
                </ul>

                <div className="w-full bg-base-white px-2 pb-0.5 mb-2 border border-solid border-base-grey flex gap-x-2 justify-between items-center">
                  <InputText id={"newLocation"} name={"newLocation"} type={"text"} updateValue={true}
                    placeholder={"Suggest a location"} className={"border-none pl-0"}
                    value={newLocation} onChange={handleNewLocation} />
                  <Icons.Plus id="add-location-icon" size={"m"} className={"cursor-pointer"}
                    onClick={onAddLocation} />
                </div>
            </>}

            {props.enableDatePicker &&
              <InputText id="date" name="date" type="date"
                label={props.dateFieldLabel || 'Select Meeting Date'} />}

            <InputTextArea id="message" rows={5} placeholder="Enter message" name="message" label={props.messageFieldLabel || 'Message'}
              required={true} />

            <p className="py-2">
              {props.privacyMessage || 'Your information will be used in accordance with our '}
              <Link 
                aria-label={props.privacyLinkLabel || "Privacy policy"}
                href={props.privacyLinkUrl || "privacy"}
                label={props.privacyLinkLabel || "Privacy policy"}
                className="text-base-dark-grey font-normal"
                target="_blank" />
            </p>

            {/*<div>
              {(count > 1 && imageUrl) &&
                <Captcha captchaMessage={props.captchaMessage}
                  imageUrl={imageUrl}
                  audioUrl={audioUrl}
                  randomString={randomString}
                  action={handleCaptchaReset} />}
            </div>*/}
          </div>
        </Form>
      )}
    </Box>
  );
}
